import { useHasUnbounceBar } from '@gik/core/hooks/UnbouceHooks';
import { useBemCN } from '@gik/core/utils/bemBlock';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import { Sticky } from '@gik/ui-legacy/Sticky';
import { AppHeader } from '@gik/ui-legacy/gik/AppHeader/AppHeader';
import type React from 'react';

export type IAppHeaderStickyProps = {
  navBarAttachment?: React.ReactNode;
  className?: string;
};

function AppHeaderStickyComp({ navBarAttachment, className }: IAppHeaderStickyProps) {
  const bem = useBemCN('app-header-sticky', '');
  const unbounce = useHasUnbounceBar();

  return (
    <Sticky {...bem(null, [{ unbounce }], className)}>
      <AppHeader />
      {navBarAttachment}
    </Sticky>
  );
}

export const AppHeaderSticky = withComponentErrorBoundary(AppHeaderStickyComp);
